import { IconButton, Stack, InputAdornment, Typography } from '@mui/material'
import React from 'react'
import { Icon, Input, showToast } from '../../../../components/ui'

const TabShipper = (props) => {
    const cariShipper = (data) => {
        if (data === 'search') {
            if (props.jobServiceType === 'Import') {
                props.setTipe(2);
                props.setTitleModal('Shipper');
                localStorage.setItem("ContactType", 2);
                props.handleClick();
            } else {
                showToast({ type: 'error', message: "Please Select Job Type First!" });
            }
        }
        else if (data === 'delete') {
            props.setIdShipper(0);
            props.setShipperName('');
            props.setShipperAddress('');
        }
    }
    return (
        <>
            <Typography
                sx={{
                    color: 'var(--Blue-Primary-1, #083A50)',
                    fontFamily: 'Nunito',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: 'normal',
                }}
            >
                Shipper
            </Typography>

            <Stack spacing={'16px'} direction="row" className='mt-2'>
                <Input
                    label={'Code'}
                    value={props.idShipper}
                    disabled
                    formControlProps={{
                        sx: {
                            marginTop: '24px'
                        }
                    }}
                    inputBaseProps={{
                        readOnly: true
                    }}
                />

                <Input
                    label="Name"
                    variant="standard"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    value={props.ShipperName}
                    type='text'
                    formControlProps={{
                        sx: {
                            width: '100%',
                            marginTop: '24px'
                        }
                    }}
                    inputBaseProps={{
                        readOnly: true,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => cariShipper('delete')}
                                    disabled={props.isApproved}
                                    hidden={props.ShipperName && !props.isApproved ? false : true}
                                >
                                    <Icon
                                        iconName={'close'}
                                        svgIconProps={{
                                            fontSize: 'small',
                                            htmlColor: '#0087C2',
                                            sx: {
                                                height: '12px',
                                                width: '12px'
                                            }
                                        }}
                                    />
                                </IconButton>

                                <IconButton
                                    onClick={() => cariShipper('search')}
                                    disabled={props.isApproved}
                                    hidden={props.isApproved}
                                >
                                    <Icon
                                        iconName={'search'}
                                        svgIconProps={{
                                            fontSize: 'small',
                                            htmlColor: '#0087C2',
                                            sx: {
                                                height: '12px',
                                                width: '12px'
                                            }
                                        }}
                                    />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                    disabled
                />
            </Stack>

            <Input
                label={'Address'}
                value={props.ShipperAddress}
                multiline
                fullWidth
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '24px'
                    }
                }}
                inputBaseProps={{
                    readOnly: true,
                    rows: 4,
                    sx: {
                        padding: '8px',
                    },
                }}
                disabled
            />
        </>
    )
}

export default TabShipper